/**
 * LPgenerator main API
 * API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { Http, Headers, URLSearchParams }                    from '@angular/http';
import { RequestMethod, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { Response, ResponseContentType }                     from '@angular/http';

import { Observable }                                        from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import * as models                                           from '../model/models';
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class EditorApi {
    protected basePath = 'https://swagger.lpg/api/v1';
    public defaultHeaders: Headers = new Headers();
    public configuration: Configuration = new Configuration();

    constructor(protected http: Http, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
        }
    }

    /**
     * Удалить пользовательскую секцию
     * Удалить пользовательскую секцию
     * @param id id секции
     */
    public deleteSection(id: number, extraHttpRequestParams?: any): Observable<{}> {
        return this.deleteSectionWithHttpInfo(id, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить список всех категорий
     * Получение списка всех категорий без постраничного разбиения
     */
    public getCategories(extraHttpRequestParams?: any): Observable<Array<models.Category>> {
        return this.getCategoriesWithHttpInfo(extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить список всех активных цветов
     * Получение списка всех цветов доступных для фильтрации секций
     */
    public getColors(extraHttpRequestParams?: any): Observable<Array<models.Color>> {
        return this.getColorsWithHttpInfo(extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить список секций
     * Получение списка секций как пользовательских, так и общих
     * @param category Фильтр по идентификатору категории
     * @param sectionType Фильтр типу категории
     * @param colors Фильтр по идентификаторам цветов, разделенных запятой. Например 1,12,3
     */
    public getEditorSections(category?: number, sectionType?: number, colors?: string, extraHttpRequestParams?: any): Observable<models.InlineResponse2006> {
        return this.getEditorSectionsWithHttpInfo(category, sectionType, colors, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить рандомный список секций для генератора
     * Получение рандомных секций из списка общих
     * @param sections Список обьектов с типами категорий. Например [{\&quot;section_type\&quot;: 1}, {\&quot;section_type\&quot;: 4}]
     * @param category Фильтр по идентификатору категории
     * @param color Фильтр по идентификаторам цветов. Параметр множественный. Можно передавать color&#x3D;1&amp;color&#x3D;12
     */
    public getRandomSections(sections: string, category?: number, color?: number, extraHttpRequestParams?: any): Observable<Array<models.Section>> {
        return this.getRandomSectionsWithHttpInfo(sections, category, color, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }


    /**
     * Удалить пользовательскую секцию
     * Удалить пользовательскую секцию
     * @param id id секции
     */
    public deleteSectionWithHttpInfo(id: number, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/editor/sections/${id}/'
                    .replace('${' + 'id' + '}', String(id));

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSection.');
        }
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Delete,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить список всех категорий
     * Получение списка всех категорий без постраничного разбиения
     */
    public getCategoriesWithHttpInfo(extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/editor/categories/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить список всех активных цветов
     * Получение списка всех цветов доступных для фильтрации секций
     */
    public getColorsWithHttpInfo(extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/editor/colors/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить список секций
     * Получение списка секций как пользовательских, так и общих
     * @param category Фильтр по идентификатору категории
     * @param sectionType Фильтр типу категории
     * @param colors Фильтр по идентификаторам цветов, разделенных запятой. Например 1,12,3
     */
    public getEditorSectionsWithHttpInfo(category?: number, sectionType?: number, colors?: string, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/editor/sections/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        if (category !== undefined) {
            queryParameters.set('category', <any>category);
        }

        if (sectionType !== undefined) {
            queryParameters.set('section_type', <any>sectionType);
        }

        if (colors !== undefined) {
            queryParameters.set('colors', <any>colors);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить рандомный список секций для генератора
     * Получение рандомных секций из списка общих
     * @param sections Список обьектов с типами категорий. Например [{\&quot;section_type\&quot;: 1}, {\&quot;section_type\&quot;: 4}]
     * @param category Фильтр по идентификатору категории
     * @param color Фильтр по идентификаторам цветов. Параметр множественный. Можно передавать color&#x3D;1&amp;color&#x3D;12
     */
    public getRandomSectionsWithHttpInfo(sections: string, category?: number, color?: number, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/editor/random-sections/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // verify required parameter 'sections' is not null or undefined
        if (sections === null || sections === undefined) {
            throw new Error('Required parameter sections was null or undefined when calling getRandomSections.');
        }
        if (category !== undefined) {
            queryParameters.set('category', <any>category);
        }

        if (sections !== undefined) {
            queryParameters.set('sections', <any>sections);
        }

        if (color !== undefined) {
            queryParameters.set('color', <any>color);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/api/api/EditorApi.ts